<template>
  <section id="email">
    <v-parallax dark src="@/assets/img/bgHero.jpg" height="200">
      <v-row justify="center" class="mt-16">
            <v-col cols="12" md="6" xl="8">
              <h3 class="display-1 font-weight-bold mb-4" align="center">{{email_address}}</h3>
            </v-col>
      </v-row>
      <div class="svg-border-waves text-white">
        <v-img src="@/assets/img/borderWaves.svg" />
      </div>
    </v-parallax>
    <v-container>
      <v-row justify="center">
        <v-col cols="4">
          <v-card
              class="mx-auto"
              tile
              min-height="1000"
          >
            <v-list two-line>
              <v-subheader>
                <h2>INBOX</h2>
                <v-spacer></v-spacer>
                <div>
                  <v-btn
                      fab
                      dark
                      small
                      color="purple"
                      :loading = isLoading
                      @click="refreshInbox()"
                  >
                    <v-icon dark>
                      mdi-refresh
                    </v-icon>
                  </v-btn>
                </div>
              </v-subheader>
              <v-list-item-group
                  v-model="selectedItem"
                  color="primary"
              >
                <template v-for="(item, i) in messages">
                <v-list-item
                    :key="i"
                    @click="showMessage(i, item)"
                >
                  <v-list-item-content>
                    <v-list-item-title v-text="item.subject" :class="{'font-weight-bold': !item.seen}"></v-list-item-title>
                  </v-list-item-content>

                </v-list-item>
                  <v-divider></v-divider>
                </template>
                <template v-if="messages.length===0">
                  <v-card-text class="font-italic">
                    You have no new mail.
                  </v-card-text>
                </template>
              </v-list-item-group>
            </v-list>
          </v-card>

        </v-col>
        <v-col cols="8">
          <v-card
              class="mx-auto"
              tile
              min-height="1000"
          >
            <v-card-title>{{message.subject}}</v-card-title>
            <v-card-subtitle>{{message.from}}</v-card-subtitle>
            <v-card-text v-html="message.html_body">
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>

export default {
  computed: {
    email_address() {
      return this.$store.getters.getEmailAddress
    },
    messages() {
      return this.$store.state.messages
    },
  },
  data: () => ({
    selectedItem: -1,
    message : '',
    isLoading: false
  }),
  methods: {
    async showMessage(index, item) {
      const email = this.$store.getters.getEmailAddress
      let id = item.id
      await this.$store.dispatch('fetchEmailBody', {email, id ,index})
      this.message = this.$store.getters.getEmailDetailByIndex(index)
    },
    async refreshInbox() {
      this.isLoading = true
      await this.delay(1500)
      const emailAddress = this.$store.getters.getEmailAddress
      if (emailAddress === "") {
        this.isLoading = false
        await this.$router.push({name: 'Home'})
        return
      }
      await this.$store.dispatch('fetchMessages', emailAddress)
      this.isLoading = false
      this.selectedItem = -1
    },
    delay(milliseconds){
      return new Promise(resolve => {
        setTimeout(resolve, milliseconds);
      });
    }
  }
}
</script>

<style scoped>
section {
  position: relative;
}
.svg-border-waves .v-image {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3rem;
  width: 100%;
  overflow: hidden;
}

#email {
  z-index: 0;
}
.svg-border-waves img {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  margin-bottom: -2px;
  z-index: -1;
}

.card {
  min-height: 300px;
  padding: 10px;
  transition: 0.5s ease-out;
}

.card .v-image {
  margin-bottom: 15px;
  transition: 0.75s;
}

.card h1 {
  margin-bottom: 10px;
}

.zoom-efect {
  transform: scale(1.1);
}

.up {
  transform: translateY(-20px);
  transition: 0.5s ease-out;
}
</style>